import React from 'react'
import styled from 'styled-components'
import Icon from '../../general/Icon'
import Tooltip, { StyledTooltip } from '../../general/Tooltip'
import PropTypes from 'prop-types'

const Decoration = ({ decoration, showName }) => (
	<StyledDecoration showName={showName}>
		<Tooltip title={!showName ? decoration.name : null}>
			<Icon name={decoration.type === 'emblem' ? 'shield' : 'stamp'} />
		</Tooltip>
		{showName && decoration.name}
	</StyledDecoration>
)

Decoration.propTypes = {
	decoration: PropTypes.object.isRequired,
	showName: PropTypes.bool
}

Decoration.defaultProps = {
	showName: false
}

export const StyledDecoration = styled.span`
	color: ${props => props.theme.textLight};
	vertical-align: middle;

	align-items: center;
	display: inline-flex;
	gap: 0.5rem;

	&, > ${StyledTooltip} {
		height: 20px;
	}

	${props => !props.showName && `
		margin-left: 0.35rem;
	`}
`

export default Decoration
